export const TOOLTIP_STORAGE_KEY_PROVIDER = "sked-85-95-96";
export const TOOLTIP_STORAGE_KEY_CONSUMER = "sked-85-109";

export const featuresProvider = [
  {
    name: "New Features are available!",
    steps: [
      {
        content: [
          //"Schedule Editing",
          "Creating new schedule",
          "Seeing Sessions",
          "Training History",
          "Seeing active customers",
        ],
        isCenter: true,
      },
    ],
  },
  // {
  //   name: "Schedule Editing:",
  //   steps: [
  //     {
  //       content: "now you can modify existing schedules.",
  //       position: { top: 20, left: 60 },
  //       arrowPosition: "left",
  //     },
  //     {
  //       content: "you have to navigate to Schedule page!",
  //       position: { top: 140, left: 100 },
  //       arrowPosition: "left",
  //       redirectionUrl: "/schedules",
  //       isToggleMenu: true,
  //     },
  //     {
  //       content: "to modify existing schedule click action menu.",
  //       position: { top: 90, right: 45 },
  //       arrowPosition: "right",
  //       redirectionUrl: "/schedules?showFeatureTooltip=true",
  //       isToggleMenu: true,
  //     },
  //     {
  //       content: "choose 'Edit Schedule' option from the list!",
  //       position: { top: 170, right: 205 },
  //       arrowPosition: "right",
  //       redirectionUrl: "/schedules",
  //     },
  //   ],
  // },
  {
    name: "Add Schedule:",
    steps: [
      {
        content: "now you can add new schedule from Schedule Page!",
        isCenter: true,
      },
      {
        content: "you have to navigate to Schedule Page!",
        position: { top: 120, left: 110 },
        arrowPosition: "left",
        redirectionUrl: "/schedules",
        isToggleMenu: true,
      },
      {
        content:
          "Click 'Create New Schedule' botton below to create new record.",
        position: { bottom: 100, left: 60 },
        arrowPosition: "bottom",
        isToggleMenu: true,
      },
    ],
  },
  {
    name: "Seeing Sessions:",
    steps: [
      {
        content: "you can see planned Sessioins",
        isCenter: true,
      },
      {
        content: "you have to navigate to Sessions Page!",
        position: { top: 65, left: 170 },
        arrowPosition: "left",
        redirectionUrl: "/sessions",
        isToggleMenu: true,
      },
    ],
  },
  {
    name: "Traning History:",
    steps: [
      {
        content:
          "you can see how many sessions has been occured for each schedule!",
        isCenter: true,
        position: { top: 20, left: 60 },
      },
      {
        content: "you can navigate to Training History page!",
        position: { top: 103, left: 140 },
        arrowPosition: "left",
        redirectionUrl: "/history/byschedule",
        isToggleMenu: true,
      },
      // {
      //   content: "or navigate from Schedule actions:",
      //   position: { top: 90, right: 45 },
      //   arrowPosition: "right",
      //   redirectionUrl: "/schedules?showFeatureTooltip=true",
      //   isToggleMenu: true,
      // },
      // {
      //   content: "select 'Training History' from schedule action options!",
      //   position: { top: 310, right: 205 },
      //   arrowPosition: "right",
      //   redirectionUrl: "/schedules",
      // },
    ],
  },
  {
    name: "Active customers:",
    steps: [
      {
        content: "you can see active customers.",
        isCenter: true,
      },
      {
        content: "you have to navigate to Customers Page!",
        position: { top: 155, left: 110 },
        arrowPosition: "left",
        redirectionUrl: "/customers",
        isToggleMenu: true,
      },
    ],
  },
];

export const featuresConsumer = [
  {
    name: "New Features are available!",
    steps: [
      {
        content: ["Training History", "Language Switcher"],
        isCenter: true,
      },
    ],
  },

  {
    name: "Training History:",
    steps: [
      {
        content: "now you can see how many sessions you completed for month.",
        position: { bottom: 80, right: 50 },
        arrowPosition: "bottom",
        redirectionUrl: "/history",
      },
      {
        content: "you can select month!",
        position: { top: 150, left: 30 },
        arrowPosition: "top",
        redirectionUrl: "/history",
      },
      {
        content: "You will see how many sessions has been passed or canceled",
        isCenter: true,
        redirectionUrl: "/history?showFeatureTooltip=true",
      },
    ],
  },

  {
    name: "New language is available:",
    isCenter: true,
    steps: [
      {
        content: "you can change language from burger menu!",
        position: { top: 20, left: 60 },
        arrowPosition: "left",
        isToggleMenu: true,
      },
      {
        content: "Click flag to change language.",
        position: { top: 330, left: 10 },
        redirectionUrl: "/sessions?showFeatureTooltip=true",
        isToggleMenu: true,
      },
    ],
  },
];
